// Item Img
import img1 from '../../assets/img/causes/causes-1.png'
import img2 from '../../assets/img/causes/causes-2.png'
import img3 from '../../assets/img/causes/causes-3.png'
import img4 from '../../assets/img/causes/causes-4.png'
import img5 from '../../assets/img/causes/causes-5.png'
import img6 from '../../assets/img/causes/causes-6.png'

// Import Icon
import Icon from "../../assets/img/icon/cal.png"
import Icon1 from "../../assets/img/icon/user.png"




export const CausesData = [
    {
        img: img1,
        category:"Education & integration",
        goal:"Open cohorts",
        heading: "Children’s education & Swedish school life",
        para:`Homework circles, language practice, and parent information so families understand school routines and rights in Sweden.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img2,
        category:"Badminton",
        goal:"Year-round",
        heading: "Badminton — main club activity",
        para:`Weekly sessions, coaching, and internal tournaments. Our flagship sport welcomes beginners through to competitive players.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img3,
        category:"Culture",
        goal:"Seasonal",
        heading: "Heritage, festivals & arts",
        para:`Eid, Independence Day, music, and storytelling—spaces where children and elders celebrate identity together.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img4,
        category:"Integration",
        goal:"Ongoing",
        heading: "Integration meet-ups & civic orientation",
        para:`Informal talks and Q&amp;A on topics like healthcare, housing, and civic life—always alongside peers who share your background.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img5,
        category:"Seasonal sports",
        goal:"By season",
        heading: "Swimming, cricket & football blocks",
        para:`We organise swimming sessions and pitch-time for cricket and football when weather and venues allow—rotating with the Swedish seasons.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    },
    {
        img: img6,
        category:"Social",
        goal:"Monthly",
        heading: "Social gatherings & family days",
        para:`Coffee evenings, picnics, and mixed-age socials that build friendships across cities and support newcomers.`,
        IconAdmin:Icon,
        DateIcon:Icon1
    }
]
